import PropTypes from 'prop-types';
import { forwardRef, useEffect } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import { Badge, Avatar } from '@mui/material';
import Image from '../image';
// ----------------------------------------------------------------------

const getCharAtName = (name) => name && name.charAt(0).toUpperCase();

const getColorByName = (name) => {
  if (['ا', 'ج', 'ذ', 'ص', 'غ', 'ن'].includes(getCharAtName(name))) return 'primary';
  if (['ب', 'چ', 'ر', 'ض', 'ک', 'و'].includes(getCharAtName(name))) return 'info';
  if (['پ', 'ح', 'ز', 'ط', 'گ', 'ه'].includes(getCharAtName(name))) return 'success';
  if (['ت', 'خ', 'س', 'ظ', 'ل', 'ی'].includes(getCharAtName(name))) return 'warning';
  if (['ث', 'د', 'ش', 'ع', 'م'].includes(getCharAtName(name))) return 'error';
  return 'default';
};

// ----------------------------------------------------------------------

const CustomAvatar = forwardRef(
  ({ color, name = '', personel, BadgeProps, children, sx, ...other }, ref) => {
    const theme = useTheme();

    const charAtName = getCharAtName(name);

    const colorByName = getColorByName(name);

    const colr = color || colorByName;

    useEffect(() => {
      console.log(`http://192.168.50.113:8083/api/V1/User/avatar/${personel}`);
    }, [personel]);

    // const renderContent =
    //   colr === 'default' ? (
    //     <Avatar ref={ref} sx={sx} {...other}>
    //       {name && charAtName}
    //       {children}
    //     </Avatar>
    //   ) : (
    //     <Avatar
    //       ref={ref}
    //       sx={{
    //         color: theme.palette[colr]?.contrastText,
    //         backgroundColor: theme.palette[colr]?.main,
    //         fontWeight: theme.typography.fontWeightMedium,
    //         ...sx,
    //       }}
    //       {...other}
    //     >
    //       {name && charAtName}
    //       {children}
    //     </Avatar>
    //   );

    const renderContent =
      personel === undefined || personel === null ? (
        <Avatar
          ref={ref}
          sx={{
            color: theme.palette[colr]?.contrastText,
            backgroundColor: theme.palette[colr]?.main,
            fontWeight: theme.typography.fontWeightMedium,
            ...sx,
          }}
          {...other}
        >
          {name && charAtName}
          {children}
        </Avatar>
      ) : (
        <Image
          src={`http://192.168.50.113:8083/api/V1/User/avatar/${personel}`}
          sx={{
            width: '24px',
            height: '24px',
          }}
        />
      );

    return BadgeProps ? (
      <Badge
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        {...BadgeProps}
      >
        {renderContent}
        {/* <Image src={`http://192.168.50.113:8083/api/V1/User/avatar/${personel}`} /> */}
      </Badge>
    ) : (
      renderContent
    );
  }
);

CustomAvatar.propTypes = {
  sx: PropTypes.object,
  name: PropTypes.string,
  personel: PropTypes.string,
  children: PropTypes.node,
  BadgeProps: PropTypes.object,
  color: PropTypes.oneOf([
    'default',
    'primary',
    'secondary',
    'info',
    'success',
    'warning',
    'error',
  ]),
};

export default CustomAvatar;
